var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 6,
    viewBox: "0 0 86 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line1",
    d: "M3 5.66667C4.47276 5.66667 5.66667 4.47276 5.66667 3C5.66667 1.52724 4.47276 0.333333 3 0.333333C1.52724 0.333333 0.333333 1.52724 0.333333 3C0.333333 4.47276 1.52724 5.66667 3 5.66667ZM83 5.66667C84.4728 5.66667 85.6667 4.47276 85.6667 3C85.6667 1.52724 84.4728 0.333333 83 0.333333C81.5272 0.333333 80.3333 1.52724 80.3333 3C80.3333 4.47276 81.5272 5.66667 83 5.66667ZM3 3.5L83 3.5V2.5L3 2.5V3.5Z",
    fill: "#298700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchBorder);
export default __webpack_public_path__ + "static/media/match_border.7f5b39be0f49b239babcd50698a8ccd2.svg";
export { ForwardRef as ReactComponent };